// The ?src= signup attribution, carried from the signup page to account creation and onboarding in a cookie.
export const SIGNUP_SOURCE_COOKIE = "hapo_src";
const SOURCE_RE = /^[a-z0-9_-]{1,60}$/;
const COOKIE_RE = /(?:^|;\s*)hapo_src=([^;]+)/;

export function isValidSignupSource(src: string | null | undefined): src is string {
  return !!src && SOURCE_RE.test(src);
}

export function signupSourceFrom(cookieHeader: string | null | undefined): string | undefined {
  const m = cookieHeader?.match(COOKIE_RE);
  if (!m) return undefined;
  try {
    const v = decodeURIComponent(m[1]);
    return isValidSignupSource(v) ? v : undefined;
  } catch {
    return undefined;
  }
}
